// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZeVM","label":"styles_label__XrnCj"};